"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defineActionReducers = defineActionReducers;
exports.safeCombineReducers = safeCombineReducers;
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _redux = require("redux");
function defineActionReducers(reducers) {
  var initialState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments.length > 1 ? arguments[1] : undefined;
    if (reducers[action.type]) {
      return reducers[action.type](state, action);
    }
    return state;
  };
}
function safeCombineReducers(hash) {
  return (0, _isEmpty2.default)(hash) ? function (state) {
    return state || null;
  } : (0, _redux.combineReducers)(hash);
}